const { Swiper, Pagination, Navigation, EffectFade } = require("swiper");

Swiper.use([Pagination, Navigation, EffectFade]);

function initSwiper() {
    const sliderEl = document.querySelector('div.js-topBanerSwiper');
    const sliderPagination = document.querySelector('div.jsSwiperPagination');
    const sliderNavPrev = document.querySelector('button.jsSwiperNav--prev');
    const sliderNavNext = document.querySelector('button.jsSwiperNav--next');
    
    if (!sliderEl) {
        return;
    }
    
    const swiper = new Swiper(sliderEl.querySelector('div.jsSwiper'), {
        effect: 'fade',
        autoplay: false,
        slidesPerView: 1,
        speed: 300,
        
        pagination: {
            el: sliderPagination,
            type: 'bullets',
            clickable: true
        },
        navigation: {
            prevEl: sliderNavPrev,
            nextEl: sliderNavNext
        }
    });
}

initSwiper();